import React from "react";
import { BURGUNDY } from "../../Bureau/bureauTokens";

function initials(name, lastName) {
  const first = (name || "").trim().charAt(0);
  const last = (lastName || "").trim().charAt(0);
  return (first + last).toUpperCase() || "?";
}

function UserAvatar({ name, lastName, picture, size = 36 }) {
  if (picture) {
    return (
      <img
        src={picture}
        alt={name || ""}
        className="flex-shrink-0 rounded-full object-cover"
        style={{ width: size, height: size }}
      />
    );
  }

  return (
    <div
      className="flex-shrink-0 flex items-center justify-center text-white font-bold"
      style={{ width: size, height: size, borderRadius: "50%", background: BURGUNDY, fontSize: size * 0.36 }}
    >
      {initials(name, lastName)}
    </div>
  );
}

export default UserAvatar;
